<template>
  <div>
    <b-alert id="alertaRelatoProblema" variant="success" dismissible :show="alerta.visivel" @dismissed="alerta.visivel=false">
      <div>Sua mensagem foi enviada com sucesso!</div>
    </b-alert>

    <form-group id="categoria" label="Escolha a categoria que mais se aproxima do assunto de sua mensagem:" :text="{ required: 'Obrigatório selecionar a categoria' }" :field="$v.categoriaRelato">
      <select class="form-control" v-model="categoriaRelato">
        <option v-for="categoria in categorias" v-bind:key="categoria.id" :value="categoria.nome">{{categoria.nome}}</option>
      </select>
    </form-group>
    <form-group id="duvida" label="Algum bug com a plataforma? Relate o que aconteceu e ajude a gente melhorar para você!" :text="{ required: 'Obrigatório informar um texto sobre seu relato' }" :field="$v.textoProblema">
      <textarea class="form-control" rows="4" v-model="textoProblema"></textarea>
    </form-group>
    <div class="text-center">
      <button class="btn btn-primary mt-2 registrar-problema" @click="enviarRelatoProblema()" :disabled="submit">
        <template v-if="submit">
          <i class="fas fa-spinner fa-spin"></i> Enviando...
        </template>
        <template v-else>
          Enviar
        </template>
      </button>
    </div>
  </div>
</template>

<script>
import RelatoProblemaAPI from '@/api/relato-problema-api'
import FormGroup from '@/core/components/FormGroup'
import { required } from 'vuelidate/lib/validators'
import { TipoCategoriaRelatoUtil } from '@/core/types/tipo-categoria-relato'

export default {
  name: 'RelateUmProblema',
  components: { FormGroup },
  props: {
    ementaId: Number
  },
  data () {
    return {
      textoProblema: '',
      categoriaRelato: '',
      alerta: { visivel: false },
      submit: false,
      categorias: []
    }
  },
  mounted () {
    this.categorias = TipoCategoriaRelatoUtil.listar()
  },
  validations: {
    categoriaRelato: { required },
    textoProblema: { required }
  },
  methods: {
    enviarRelatoProblema: function () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$v.$reset()
        this.submit = true
        let url = window.location.href
        RelatoProblemaAPI.enviarRelatoProblema(this.ementaId, this.textoProblema, this.categoriaRelato, url).then(() => {
          this.alerta.visivel = true
        }).then(() => {
          this.textoProblema = ''
          this.categoriaRelato = ''
          this.submit = false
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
